import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const distributeRoutes: CustomRouteRecordRaw = {
  path: 'distribute',
  name: 'distribute',
  component: EmptyLayout,
  meta: {
    title: '分销活动管理',
    iconfont: 'icon-todo-line',
    requiredPermission: 'distribute'
  },
  children: [
    {
      path: 'activity',
      name: 'activity',
      component: () => import('@/views/distribute/activity-list.vue'),
      meta: {
        title: '活动列表',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.activity',
      },
    },
    {
      path: 'poster',
      name: 'poster',
      component: () => import('@/views/distribute/poster-list.vue'),
      meta: {
        title: '海报列表',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.poster',
      },
    },
    {
      path: 'distribute-list',
      name: 'distributeList',
      component: () => import('@/views/distribute/distribute-list.vue'),
      meta: {
        title: '分销商列表',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.list',
      },
    },
    {
      path: 'distributor-poster-list',
      name: 'distributorPosterList',
      component: () => import('@/views/distribute/distributor-poster-list.vue'),
      meta: {
        title: '分销商海报',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.distributor.poster.list',
      },
    },
    {
      path: 'distribute-order-list',
      name: 'distributeOrderList',
      component: () => import('@/views/distribute/order-list.vue'),
      meta: {
        title: '分销商订单',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.order.list',
      },
    },
    {
      path: 'withdraw-list',
      name: 'withdraw-list',
      component: () => import('@/views/distribute/withdraw-list.vue'),
      meta: {
        title: '活动提现',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.withdraw.list',
      },
    },
    {
      path: 'wallet-withdraw-list',
      name: 'wallet-withdraw-list',
      component: () => import('@/views/distribute/wallet-withdraw-list.vue'),
      meta: {
        title: '钱包提现',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.wallet.withdraw.list',
      },
    },
    {
      path: 'report-list',
      name: 'DistributePoster',
      component: () => import('@/views/distribute/report-list.vue'),
      meta: {
        title: '分销数据报表',
        iconfont: 'icon-article-line1',
        requiredPermission: 'distribute.report.list',
      },
    }
  ],
}
